<template>
  <div>
    <!-- 导航 -->
    <el-breadcrumb>
      <el-breadcrumb-item>
        <router-link to="./">首页</router-link>
      </el-breadcrumb-item>
      <el-breadcrumb-item>提成结算</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 主体内容 -->
    <div class="content">
      <el-form inline label-position="right" label-width="60px" size="small" class="query-form">
       <el-form-item label="月份">
          <el-date-picker
            v-model="query.month"
            type="month"
            value-format="yyyy-MM"
            @change="getList()"
          ></el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="getList();">查询</el-button>
        </el-form-item>
      </el-form>

      <div style="height:20px;"></div>
      <el-card class="box-card collectCard" shadow="always">
        <div class="clearfix" slot="header">
          <span>月提成结算记录</span>
        </div>
        <div class="index-card" style="height:auto;">
          <!-- 列表定义 -->
          <el-table
            v-loading="loading"
            :data="tableData"
            ref="tableData"
            border
            stripe
            style="width:100%;"
          >
            <el-table-column prop="month" label="月份"></el-table-column>
            <el-table-column prop="userName" label="员工"></el-table-column>
            <el-table-column prop="totalAmount" label="总业绩"></el-table-column>
            <el-table-column prop="percent" label="提点"></el-table-column>
            <el-table-column prop="adviserAmount" label="提成总额"></el-table-column>
          </el-table>

          <!-- 分页条 -->
          <div class="block" style="margin-top:20px;">
            <el-pagination
              background
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="currentPage4"
              :page-sizes="[10, 20, 30, 50,100]"
              :page-size="pageSize"
              layout="total, sizes,prev, pager, next, jumper"
              :total="total"
            ></el-pagination>
          </div>
        </div>
      </el-card>
    </div>
  </div>
</template>

<script>
import echarts from "echarts";
import "echarts/theme/macarons.js";
import url from "@/plugins/urlHelper.js";
import SelectAbroad from "@/components/SelectAbroad";
export default {
  data() {
    return {
      domain: url.getDomain(),
      query: {}, //对象
      loading: false,
      currentPage4: 1,
      pageSize: 10,
      total: 0,
      tableData: [],
      dialogVisible: false,
      submiting: false,
      list: [] //数据详情
    };
  },
  components: {
    SelectAbroad
  },
  methods: {
    handleSizeChange(val) {
      this.pageSize = val;
      this.currentPage4 = 1;
      this.getList();
    },
    handleCurrentChange(val) {
      this.currentPage4 = val;
      this.getList();
    },
    //筛选
    filterTag(filter) {
      var val = filter["isEnable"][0];
      this.form.isEnable = val;
      //刷新列表
      this.getList();
    },
    //排序
    sortChange(sortColumn) {
      this.form.sort = sortColumn.prop;
      this.form.order = sortColumn.order;
      //刷新列表
      this.getList();
    },
    getList: function() {
      var _this = this;
      _this.loading = true;
      var params = _this.query;
      params.pageindex = _this.currentPage4;
      params.pagesize = _this.pageSize;
      params.key = _this.key;
      var link = url.getCollect("GetMonthPercentage");
      $.get(link, params, data => {
        _this.loading = false;
        _this.tableData = data.list;
        _this.total = data.total;
      });
    }
  },
  created() {},
  mounted() {
    //初始化时间
    var now = new Date();
    var month = now.getMonth() + 1;
    var result = 1;
    for (var i = 0; i < month; i++) {
      var temp = month - i;
      if (temp == 1 || temp == 4 || temp == 7 || temp == 10) {
        result = temp;
        break;
      }
    }
    this.query.time = now.getFullYear() + "-" + result;
    //加载列表
    this.getList();
  }
};
</script>

<style>
.query-form {
  margin-top: 20px;
  padding-top: 25px;
  background: #f2f2f2;
}
.el-form-item--small.el-form-item {
  margin-right: 0px;
}
.el-button--primary {
  margin-left: 10px;
}
</style>
